import { render, staticRenderFns } from "./Bills.vue?vue&type=template&id=2f6027af&"
import script from "./Bills.vue?vue&type=script&lang=js&"
export * from "./Bills.vue?vue&type=script&lang=js&"
import style0 from "./Bills.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports